'use client';

import React from 'react';

const features = [
  {
    icon: '⚙️',
    title: 'Commercial-Grade Equipment',
    desc: 'We use professional-grade pressure washers and soft wash systems delivering consistent, powerful results every time.',
    span: 'col-span-1 md:col-span-2',
    bg: 'bg-gradient-to-br from-teal to-teal-dark',
    light: true,
  },
  {
    icon: '🧪',
    title: 'Professional Cleaning Methods',
    desc: 'Eco-friendly, surface-safe cleaning solutions that protect your property while eliminating grime.',
    span: 'col-span-1',
    bg: 'bg-white',
    light: false,
  },
  {
    icon: '🏡',
    title: 'Locally Owned & Operated',
    desc: 'We\'re your New Mexico neighbors — invested in our community and your property\'s appearance.',
    span: 'col-span-1',
    bg: 'bg-white',
    light: false,
  },
  {
    icon: '📆',
    title: 'Reliable Scheduling',
    desc: 'We show up on time, every time. Book online 24/7 through our easy scheduling system.',
    span: 'col-span-1',
    bg: 'bg-white',
    light: false,
  },
  {
    icon: '💰',
    title: 'Honest, Transparent Pricing',
    desc: 'No hidden fees, no surprises. Free estimates with clear pricing before any work begins.',
    span: 'col-span-1 md:col-span-2',
    bg: 'bg-dark-text',
    light: true,
  },
  {
    icon: '⭐',
    title: '100% Customer Satisfaction',
    desc: 'We\'re not done until you\'re thrilled. Your satisfaction is our guarantee on every job.',
    span: 'col-span-1',
    bg: 'bg-teal-light',
    light: false,
  },
];

export default function RGPSWhyUs() {
  return (
    <section className="bg-light-gray py-20 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-teal-light text-teal font-bold text-sm px-4 py-2 rounded-full mb-4">
            Why RGPS
          </div>
          <h2 className="text-dark-text font-bold mb-4" style={{ fontSize: 'clamp(1.75rem, 4vw, 2.75rem)', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            Why Homeowners Choose Us
          </h2>
          <p className="text-gray-text text-lg max-w-2xl mx-auto">
            We combine professional equipment, proven methods, and genuine care to deliver results that exceed expectations.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features?.map((f) => (
            <div
              key={f?.title}
              className={`${f?.span} ${f?.bg} rounded-2xl p-7 shadow-card hover:shadow-card-lg transition-all duration-300 hover:-translate-y-0.5`}
            >
              <div className={`text-4xl mb-4`}>{f?.icon}</div>
              <h3 className={`font-bold text-lg mb-2 ${f?.light ? 'text-white' : 'text-dark-text'}`}>
                {f?.title}
              </h3>
              <p className={`text-sm leading-relaxed ${f?.light ? 'text-white/80' : 'text-gray-text'}`}>
                {f?.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
